module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "date-mini"
  }, [_c('div', {
    staticClass: "date-container"
  }, [_c('div', {
    staticClass: "date-lg"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.currentDate) + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "dates-small"
  }, [_c('div', {
    staticClass: "date-utc"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.dateUtc) + "\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "date-stardate"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.starDate) + "\n\t\t\t")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-17835cf5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/date-mini.vue
// module id = 565
// module chunks = 0